import axios from 'axios';
import Cookie from 'universal-cookie';
import { baseUrl_api, } from './url';


export async function getTokenOrRefresh(operate="new", keyID=null, isPro=false) {
    // console.log('Fetching token from back-end...'); 
    // 删除过大的请求头字段
    delete axios.defaults.headers.common['Your-Header-Field'];

    // 修改过大的请求头字段
    axios.defaults.headers.common['Your-Header-Field'] = 'New-Value';

    const cookie = new Cookie();

    let speechToken = undefined
    if (operate === "new" && !isPro) {
        speechToken = cookie.get('speech-token');
    } else {
        speechToken = undefined;
    }

    console.log("ispro: ", isPro);

    if (speechToken === undefined) {
        try {            
            // console.log('Fetching token from back-end...');            
            // const body = {operate: operate, id: keyID, isPro: isPro}
            const body = {operate: operate, id: keyID, isPro: false}
            const res = await axios.post(baseUrl_api+'/get_speech_token', body);
            
            const token = res.data.token;
            const region = res.data.region;
            const id = res.data.id;
            

            console.log('37 Token fet?ched from back-end: ' + token , '\nid:'+id, '\nregin:'+region);
            
            cookie.set('speech-token', region + ':' + token + ':' + id, {maxAge: 300, path: '/'});
            return { authToken: token, region: region, id:id };
        } catch (err) {
            console.log(err.response.data);
            return { authToken: null, error: err.response.data };
        };
    } else {
        // console.log('Token fetched from cookie: ' + speechToken);
        // const idx = speechToken.indexOf(':');
        // return { authToken: speechToken.slice(idx + 1), region: speechToken.slice(0, idx) };
        const speechTokenParts = speechToken.split(':');
        return {
            region: speechTokenParts[0],
            authToken: speechTokenParts[1],
            id: speechTokenParts[2]
        };
    };
}

export async function sendRequest(url, postPara={}, onChunkReceived) {
    try {
        const response = await fetch(baseUrl_api + url,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postPara)
        });

        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
    
        let result = "";
        let data;
    
        while (!(data = await reader.read()).done) {
            const chunk = decoder.decode(data.value, { stream: true });
            result += chunk;
            // console.log("Received chunk:", chunk);
            // console.log("Received result:", result);
            if (onChunkReceived) {
                onChunkReceived(chunk);
            }
        }
        // console.log("Received result:", result);       
        return result;

    } catch (error) {
        console.error("Error fetching stream:", error);
    };
    
}